// export type FieldType = 'name' | 'mobile' | 'message' | 'review' | 'reference' | 'email';
// export type FieldRequirement = 'required' | 'optional' | 'locked' | 'hidden';
// export type FieldName =
//   | 'name'
//   | 'reference';
// export type FieldSettings = {
//   name: FieldName,
//   type: FieldType,
//   requirement: FieldRequirement,
//   label?: string, // t('lookup')
//   placeholder?: string, // t('lookup')
//   hidden?: boolean,
//   locked?: boolean,
//   required?: boolean,
//   lockedValue?: string,
// };

import React from 'react';
import { Form, Select, Button, Space, Row, Col, Tag, Divider } from 'antd';
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';

import { capitalize } from '../../utils/ProductSwitcher';

import {
  headerLayout,
} from './EditTeamForm';


const referenceFieldTypes = ['message', 'review', 'mobile'];
const fieldRequirements = ['required', 'optional', 'hidden'];

export function EditFieldSettingsView({ form }) {
  return (
    <>

      <Row>
        <Col
          {...headerLayout}
          style={{ fontSize: '17px', fontWeight: 'bold', display: 'inline-block', marginBottom: '10px' }}
        >
          Display Fields
        </Col>
      </Row>

      <Row justify="center">
        <Col xs={24} sm={20} md={16} lg={12} xl={10}>
          <div style={{ marginBottom: '16px', textAlign: 'center', backgroundColor: '#f0f2f5', padding: '10px', borderRadius: '4px' }}>
            <div style={{ textAlign: 'start', padding: 0 }}>
              <p>{<PlusOutlined />} <strong>Add Name Field</strong> to ask for the customer's name</p>
              <p>{<PlusOutlined />} <strong>Add Reference Field</strong> to collect a message, review, or phone no.</p>
            </div>
          </div>
          <Form.List name={['paymentDetails', 'fieldSettings']}>
            {(fields, { add, remove }) => {
              const existingFields = form.getFieldValue(['paymentDetails', 'fieldSettings']) || [];
              const hasName = existingFields.some(f => f?.name === 'name');
              const hasReference = existingFields.some(f => f?.name === 'reference');

              return (
                <>
                  {fields.map(({ key, name, ...restField }) => {
                    const currentName = form.getFieldValue(['paymentDetails', 'fieldSettings', name, 'name']);

                    return (
                      <Space
                        key={key}
                        style={{ display: 'flex', marginBottom: 8 }}
                        align="start"
                      >
                        {/* Field Name (fixed once created) */}
                        <Form.Item
                          {...restField}
                          name={[name, 'name']}
                          rules={[{ required: true }]}
                        >
                          <div style={{ width: 110, textAlign: 'start' }}>
                            {capitalize(currentName)}
                            {':'}
                          </div>
                        </Form.Item>

                        {/* Type field */}
                        <Form.Item
                          {...restField}
                          name={[name, 'type']}
                          rules={[{ required: true }]}
                        >
                          {currentName === 'reference' ? (
                            <Select style={{ width: 130 }}>
                              {referenceFieldTypes.map((t) => (
                                <Select.Option key={t} value={t}>{capitalize(t)}</Select.Option>
                              ))}
                            </Select>
                          ) : (
                            <Select disabled style={{ width: 130 }}>
                              <Select.Option value="name">Name</Select.Option>
                            </Select>
                          )}
                        </Form.Item>

                        {/* Requirement */}
                        <Form.Item
                          {...restField}
                          name={[name, 'requirement']}
                          rules={[{ required: true }]}
                        >
                          <Select style={{ width: 130 }}>
                            {fieldRequirements.map(r => (
                              <Select.Option key={r} value={r}>{capitalize(r)}</Select.Option>
                            ))}
                          </Select>
                        </Form.Item>

                        {/* Remove button */}
                        <div style={{ 
                          width: '28px', backgroundColor: 'red', color: 'white',
                          textAlign: 'center', lineHeight: '28px', marginTop: '2px',
                          borderRadius: '4px', cursor: 'pointer',
                        }}>
                          <MinusCircleOutlined onClick={() => remove(name)} />
                        </div>
                      </Space>
                    );
                  })}

                  {/* Add buttons */}
                  <Form.Item>
                    <Space>
                      {!hasName && (
                        <Button
                          type="dashed"
                          onClick={() =>
                            add({
                              name: 'name',
                              type: 'name',
                              requirement: 'optional',
                            })
                          }
                          icon={<PlusOutlined />}
                        >
                          Add Name Field
                        </Button>
                      )}
                      {!hasReference && (
                        <Button
                          type="dashed"
                          onClick={() =>
                            add({
                              name: 'reference',
                              type: 'message',
                              requirement: 'optional',
                            })
                          }
                          icon={<PlusOutlined />}
                        >
                          Add Reference Field
                        </Button>
                      )}
                    </Space>
                  </Form.Item>
                </>
              );
            }}
          </Form.List>
        </Col>
      </Row>
    </>
  );
}
